export function isCommentsComponentRegistered(): boolean {
  return document.createElement('webnotes-note-comments').constructor !== HTMLElement;
}

const getIsEditorsReady = () => {
  return (
    document.querySelectorAll('.editor-body').length === document.querySelectorAll('.react-editor-container').length
  );
};

export function onCommentsReady(callback: () => void) {
  if (isCommentsComponentRegistered() && getIsEditorsReady()) {
    callback();
    return;
  }

  let tryCount = 50;
  const IID: NodeJS.Timer | number = setInterval(() => {
    if ((isCommentsComponentRegistered() && getIsEditorsReady()) || tryCount-- <= 0) {
      callback();
      clearInterval(IID);
    } else {
      // console.info(`[${tryCount}] waiting for comments to be ready...`, getIsEditorsReady());
    }
  }, 500);
}
